/**
 * Cronômetro da faixa preta na PDP — script autônomo (defer), não depende do módulo andrade-pdp.js.
 */
(function () {
  function parsePromoEnd(target) {
    if (!target || !String(target).trim()) return 0;
    const raw = String(target).trim();
    const normalized = raw.replace(' ', 'T');
    let end = Date.parse(normalized);
    if (Number.isNaN(end)) end = Date.parse(raw);
    if (Number.isNaN(end)) return 0;
    return end;
  }

  function hidePromoBar(wrap) {
    const bar = wrap.closest('.md-pdp__promo-bar');
    if (bar) bar.hidden = true;
  }

  function initCountdown(wrap) {
    if (!(wrap instanceof HTMLElement) || wrap.dataset.mdCountdownInit === 'true') return;
    wrap.dataset.mdCountdownInit = 'true';

    const els = {
      d: wrap.querySelector('[data-cd-days]'),
      h: wrap.querySelector('[data-cd-hours]'),
      m: wrap.querySelector('[data-cd-minutes]'),
      s: wrap.querySelector('[data-cd-seconds]'),
    };

    const start = parsePromoEnd(wrap.dataset.start);
    const end = parsePromoEnd(wrap.dataset.target);
    if (!start || !end || end <= start) {
      hidePromoBar(wrap);
      return;
    }

    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const now = Date.now();
      if (now < start || now >= end) {
        hidePromoBar(wrap);
        return;
      }
      const diff = Math.max(0, end - now);
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff / 3600000) % 24);
      const m = Math.floor((diff / 60000) % 60);
      const s = Math.floor((diff / 1000) % 60);

      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);

      const daysWrap = wrap.querySelector('[data-cd-days-wrap]');
      const daysSep = wrap.querySelector('.countdown-bar__sep--days');
      const showDays = d > 0;
      if (daysWrap) daysWrap.classList.toggle('hidden', !showDays);
      if (daysSep) daysSep.classList.toggle('hidden', !showDays);
    };

    tick();
    window.setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-md-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
